import { render, staticRenderFns } from "./DialogAbout.vue?vue&type=template&id=48677714&scoped=true"
import script from "./DialogAbout.vue?vue&type=script&lang=js"
export * from "./DialogAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48677714",
  null
  
)

export default component.exports